// src/components/Layout.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import { useAuth } from '../context/AuthContext';

const Layout = ({ children }) => {
  const [sidebarExpanded, setSidebarExpanded] = useState(false);
  const { logout } = useAuth();
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setSidebarExpanded(!sidebarExpanded);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Ancho del sidebar según su estado
  const sidebarWidth = sidebarExpanded ? '200px' : '60px';

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      {/* Sidebar */}
      <Sidebar expanded={sidebarExpanded} toggleSidebar={toggleSidebar} />

      {/* Área de contenido principal */}
      <div 
        style={{ 
          marginLeft: sidebarWidth,
          transition: 'margin-left 0.2s ease',
          width: `calc(100% - ${sidebarWidth})`,
          display: 'flex', 
          flexDirection: 'column',
          overflow: 'auto',
          backgroundColor: '#e5e7e7' // Añadimos el tono gris azulado muy claro
        }}
      >
        {/* Navbar */}
        <Navbar onLogout={handleLogout} />
        
        {/* Contenido de la página */}
        <div style={{ padding: '20px',backgroundColor: '#e5e7e7' }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;